// eslint-disable-next-line no-unused-vars
const config = {
  defaultLanguage: 'en',
  supportedLanguages: [
    'en',
    'de'
  ]
}
